import { createSlice } from '@reduxjs/toolkit'
import {getTaxonomies, postTaxonomy} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  taxonomies: {},
  taxonomiesList: [],
  process:{},
  loading: "idle",
  error: null }


const taxonomySlice = createSlice({
  name: 'taxonomy',
  initialState,
  reducers: {
    clearTaxonomyError: (state)=>{
      state.error = null
      state.loading = "idle"
    },
    clearTaxonomyFields:(state)=>{
      state.taxonomies = {}
      state.loading = "loading"
    }
  },
  extraReducers: {
    [postTaxonomy.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [postTaxonomy.fulfilled]: (state, action) => {
    state.taxonomies[`level_${action.payload.level}`] = action.payload.values;
    if(Object.keys(state.taxonomies).length === 4){state.loading = "succeeded"}
    state.process=action.payload.process;
    },
    [postTaxonomy.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [getTaxonomies.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
    },
    [getTaxonomies.fulfilled]: (state, action) => {
        state.loading = "succeeded";
        state.taxonomiesList = action.payload;
      
    },
    [getTaxonomies.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
     },
    [logOut]: (state)=> initialState
  }
})

export const {clearTaxonomyError, clearTaxonomyFields} = taxonomySlice.actions;
export default taxonomySlice.reducer
